export default "__VITE_ASSET__2Xcv2T_C__"